// extracted by mini-css-extract-plugin
module.exports = {"img":"Illustrations-GdprImage-img-ad59e249","container":"Illustrations-GdprImage-container-d4cd6175"};